import React from 'react';
import Alert from 'housecall-ui/dist/DesignSystem/Feedback/Alert/Alert';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';

const useStyles = makeStyles({
  alertBanner: {
    background: '#FFF8E1',
    color: '#000000',
  },
});

const PendingMigrationBanner = () => {
  const { alertBanner } = useStyles();

  return (
    <Alert severity="warning" className={alertBanner}>
      We detected an existing Force by Mojio account with your email address. To use Vehicle GPS Tracking, we must link
      your accounts. You will keep all historic vehicle tracking data.
      <br />
      <br />
      Check your email for a message from Force by Mojio and consent to link accounts. When complete, all device billing
      will be handled by Housecall Pro. Billing updates happen every 12 hours, so check back to this page to view that
      the billing transfer has been successful. This page will refresh and you may enter your shipping address.
    </Alert>
  );
};

export default PendingMigrationBanner;
